const Routes = {
	DASHBOARD: {
		path: '/',
		exact: true,
	},
};

export default Routes;
